// 营销部副总裁菜单

let menuYxbfzc = [
    
    // {
    //     path:'/',
    //     component: "HomeView",
    //     redirect: '/home/IndexView',
    //     name: '首页',
    //     parent:true,
    //     children:[
    //         {
    //             pageAddress:"IndexView",
    //             path:"/home/IndexView",
    //             component:"IndexView",
    //             name:"实时数据",
    //         }
    //     ]

    // },
    // {
    //     path: '/p0',
    //     component: "HomeView",
    //     name: '营销管理',
	// 	disable:true,//无权限
    // },
	// {
    //     path: '/p1',
    //     component: "HomeView",
    //     name: '运营管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p2',
    //     component: "HomeView",
    //     name: '合同管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p3',
    //     component: "HomeView",
    //     name: '工程管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p4',
    //     component: "HomeView",
    //     name: '材料管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p5',
    //     component: "HomeView",
    //     name: '财务管理',
    //     disable:true,//无权限
    // },
    {
        path: '/p6',
        component: "HomeView",
        name: '项目总监管理',
        parent:true,
        redirect: '/ba/cm/projectManagerList',
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"项目总监",
                children:[
                    
                    // {
                    //     pageAddress:"ProjectManagerListView",
                    //     path:"/ba/cm/projectManagerList",
                    //     component:"ProjectManagerListView",
                    //     name:"项目总监总表"
                    // },
                    {
                        pageAddress:"cd/CDinterviewRecord",
                        path:"/cm/pm/interviewRecord",
                        hidden:true,
                        component:"CDinterviewRecord",
                        name:"项目总监管理---访谈记录"
                    },
                    {
                        pageAddress:"cd/CDprojectDirector",
                        path:"/cm/pm/projectDirector",
                        hidden:true,
                        component:"CDprojectDirector",
                        name:"查看项目总监"
                    },
                    {
                        pageAddress:"cd/CDProjectManagerEditView",
                        path:"/cd/pm/edit",
                        hidden:true,
                        component:"CDProjectManagerEditView",
                        name:"项目总监详情"
                    },
                    
                ]
            },
        ]
    },
    // {
    //     path: '/p7',
    //     component: "HomeView",
    //     name: '客户管理',
    //     disable:true,//无权限
    // },
	{
		path:'/p8',
        redirect: '/user/index',
        component: "HomeView",
        name: '系统管理',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"账户设置",
                children:[
                    // { 
                    //     path: '/user/index',
                    //     pageAddress:"commonPage/UserIndexView",
                    //     component: "UserIndexView", 
                    //     name: '员工账号' 
                    // },	
                    {
                        pageAddress:"commonPage/AccountDetail",
                        path:"/UserIndexView/detail",
                        hidden:true,
                        component:"AccountDetail",
                        name:"员工账号详情"
                    },
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"个人设置",
                children:[
                    // {
                    //     pageAddress:"cm/CMChangePWView",
                    //     path:"/cm/information/changePW",
                    //     component:"CMChangePWView",
                    //     name:"修改密码"
                    // }	
                ]
            }
        ]

    },
    {
        pageAddress:"commonPage/dataReport/printSettleForm",
        path:"/common/printSettleForm",
        component:"printSettleForm",
        hidden:true,
        name:"打印结算表"
    },
    {
        pageAddress:"commonPage/financeManage/NewXiangmushitu",
        path:"/common/New",
        hidden:true,
        name:"项目视图新建页面导出数据"
    },
    {   
        pageAddress:"commonPage/financeManage/depositPrint",
        path:"/common/depositPrint",
        hidden:true,
        name:"打印物业押金"
    },
    {
        pageAddress:"commonPage/financeManage/marginPrint",
        path:"/common/marginPrint",
        hidden:true,
        name:"打印代付投标保证金"
    },
    {
        pageAddress:"commonPage/financeManage/materialPrint",
        path:"/common/materialPrint",
        hidden:true,
        name:"打印付款申请单"
    },
    {
        pageAddress:"commonPage/financeManage/serviceFeePrint",
        path:"/common/serviceFeePrint",
        hidden:true,
        // name:"打印劳务支付"
    },
];

export default menuYxbfzc;


// WEBPACK FOOTER //
// ./src/menu/menuYxbfzc.js